export const masterStructure = [
  /*
  {
    "": {
      "Health & Incidents": 2,
    },
    options: { hideHeader: true, healthTracker: true },
  },*/
  {
    "Digital Records": {
      "Report Cards Folder": 2,
      "DSRB Folder": 1,
      "PTCL File": 4,
      "Medical Info": 8,
      "Hebrew Steps": 9,
    },
    options: { isReverse: true, isLink: true },
  },
  {
    "Attendance Summary": {
      "Attendance Exception (Today)": 96,
      "Total Absences": 94,
      "Total Lates": 95,
    },
  },
  {
    "Getting to Know You Data": { "Current Year": 33 },
    options: { insertBr: true, hideHeader: true },
  },

  {
    "Resource Links": {
      "IEP File": 5,
      "Growth Plan": 6,
      "SSF File": 7,
    },
    options: { isReverse: true, isLink: true },
  },

  {
    "Report Graph": { "Report Graph": 0 },
    options: { isGraph: true, hideHeader: true },
  },
  {
    "Report Cards (2025-26)": {
      "T1 GS": 101,
      "T1 JS": 102,
      "T2 GS": 104,
      "T2 JS": 105,
    },
  },
  {
    "Average Marks by Class (2025-26)": { term1: 103, term2: 106 },
    options: { indivMarks: true },
  },
  {
    "Report Cards (2024-25)": {
      "T1 GS": 78,
      "T1 JS": 79,
      "T2 GS": 89,
      "T2 JS": 90,
    },
  },
  {
    "Average Marks by Class (2024-25)": { term1: 80, term2: 91 },
    options: { indivMarks: true },
  },
  {
    "Report Cards (2023-24)": {
      "T1 GS": 16,
      "T2 GS": 18,
      "T1 JS": 17,
      "T2 JS": 19,
    },
  },
  {
    "Average Marks by Class (2023-24)": { term1: 42, term2: 43 },
    options: { indivMarks: true },
  },

  {
    "Report Cards (2022-23)": {
      "T1 GS": 61,
      "T2 GS": 63,
      "T1 JS": 62,
      "T2 JS": 64,
    },
  },
  {
    "Average Marks by Class (2022-23)": { term1: 65, term2: 66 },
    options: { indivMarks: true },
  },

  { "EQAO Scores": { Reading: 13, Writing: 14, Math: 15 } },
  {
    "Hebrew Levels (2025-26)": {
      "Hebrew Reading": 97,
      "Hebrew Writing": 98,
      "Hebrew Listening": 99,
      "Hebrew Speaking": 100,
    },
    options: { acadienceScores: true },
  },
  {
    "Hebrew Levels (2024-25)": {
      "Hebrew Reading": 77,
      "Hebrew Writing": 75,
      "Hebrew Listening": 76,
      "Hebrew Speaking": 77,
    },
  },
  { "Acadience (2024-25)": { Beginning: 85, Middle: 86, End: 87 } },
  { "Acadience (2023-24)": { Middle: 11, End: 12 } },

  {
    "Admissions Notes": {
      "VP Intake Notes": 35,
      "Hebrew Intake Notes": 36,
      "Admissions Screen Notes": 37,
    },
  },

  {
    Health: {
      Anaphylaxis: 46,
      "Anaphylaxis Comment": 47,
      Asthma: 48,
      "Asthma Comment": 49,
      "Serious Condition": 50,
      "Serious Condition Comment": 51,
      "Allow Acetaminophen/Tylenol": 52,
      "Acetaminophen/Tylenol Comment": 53,
    },
  },

  {
    "Resource Information": {
      Ulpan: 28,
      Shiluv: 29,
      "Ivrit MOD": 57,
      "Tanach MOD": 58,
      ELL: 59,
      "Behavioural Data": 31,
    },
  },

  {
    "Additional Information": {
      Birthdate: 56,

      "Medical Information": 32,
      "Kippah Preference": 60,
      "Photo Release": 55,
      House: 67,
      "PCR Flags": 68,
      Sex: 69,
      "Household ID": 83,
      "Field Trip Permission": 88,
    },
  },
];

export const lengthOfAddedUrls = 9; //change this when you add more to the end of the response

// Derives the chronological list of school terms (oldest first) that the "Report Graph"
// plots, by pairing up each year's "Report Cards (YYYY-YY)" and "Average Marks by Class
// (YYYY-YY)" entries above. Adding a new school year to masterStructure is enough for it
// to show up in the graph automatically — no other code needs to change.
function buildAcademicTerms(structure) {
  const reportCardsByYear = {};
  const courseAvgByYear = {};

  structure.forEach((entry) => {
    const key = Object.keys(entry).find((k) => k !== "options");
    const reportMatch = key.match(/^Report Cards \((\d{4}-\d{2})\)$/);
    const courseMatch = key.match(
      /^Average Marks by Class \((\d{4}-\d{2})\)$/,
    );

    if (reportMatch) {
      reportCardsByYear[reportMatch[1]] = entry[key];
    } else if (courseMatch) {
      courseAvgByYear[courseMatch[1]] = entry[key];
    }
  });

  const years = Object.keys(reportCardsByYear).sort(
    (a, b) => parseInt(a, 10) - parseInt(b, 10),
  );

  const terms = [];

  years.forEach((year) => {
    const reportCard = reportCardsByYear[year];
    const courseAvg = courseAvgByYear[year] || {};

    terms.push({
      year,
      termNumber: 1,
      label: `Term 1 (${year})`,
      gsIndex: reportCard["T1 GS"],
      jsIndex: reportCard["T1 JS"],
      courseIndex: courseAvg.term1,
    });
    terms.push({
      year,
      termNumber: 2,
      label: `Term 2 (${year})`,
      gsIndex: reportCard["T2 GS"],
      jsIndex: reportCard["T2 JS"],
      courseIndex: courseAvg.term2,
    });
  });

  return terms;
}

export const academicTerms = buildAcademicTerms(masterStructure);
